import React, { Fragment } from 'react';
import classnames from 'classnames';

export function inline1(header, body, media) {
  return (
    <div className="sm:flex sm:justify-between">
      {media && <div className="mb-6 sm:mb-0 sm:w-1/2">{media}</div>}
      {(header || body) && (
        <div className="sm:w-9/20">
          {header}
          {body && <div className={header && 'mt-4'}>{body}</div>}
        </div>
      )}
    </div>
  );
}

export function inline2(header, body, media) {
  return (
    <div className="sm:flex sm:flex-row-reverse sm:justify-between">
      {media && <div className="mb-6 sm:mb-0 sm:w-1/2">{media}</div>}
      {(header || body) && (
        <div className="sm:w-9/20">
          {header}
          {body && <div className={header && 'mt-4'}>{body}</div>}
        </div>
      )}
    </div>
  );
}

export function inline3(header, body, media) {
  return (
    <div className="sm:flex sm:-mx-2">
      {media && <div className="mb-6 sm:mb-0 sm:px-2 sm:w-1/3">{media}</div>}
      {(header || body) && (
        <div className="sm:flex-1 sm:px-2 sm:w-2/3">
          {header}
          {body && <div className={header && 'mt-4'}>{body}</div>}
        </div>
      )}
    </div>
  );
}

export function inline4(header, body) {
  return (
    <div className="sm:flex sm:-mx-2">
      {(header || body) && (
        <div>
          {header}
          {body && <div className={header && 'mt-4'}>{body}</div>}
        </div>
      )}
    </div>
  );
}

export function column1(header, body, media) {
  return (
    <Fragment>
      {media}
      {header && <div className={media && 'mt-8'}>{header}</div>}
      {body && <div className={(media || header) && 'mt-4'}>{body}</div>}
    </Fragment>
  );
}

export function column2(header, body, media) {
  return (
    <Fragment>
      {header}
      {media && <div className={header && 'mt-4'}>{media}</div>}
      {body && <div className={(media || header) && 'mt-8'}>{body}</div>}
    </Fragment>
  );
}

export function column3(header, body, media) {
  return (
    <div className="border-1 rounded-tiny border-gray-light h-full shadow-diffuse">
      {media && <div className="-mx-px -mt-px">{media}</div>}
      {(header || body) && (
        <div className="p-4">
          {header}
          {body && <div className={header && 'mt-4'}>{body}</div>}
        </div>
      )}
    </div>
  );
}

export function composite1(header, body, media) {
  return (
    <Fragment>
      {media}
      {(header || body) && (
        <div className={classnames('sm:flex sm:-mx-2', { 'mt-8': media })}>
          {header && <div className="sm:flex-1 sm:px-2">{header}</div>}
          {body && (
            <div className={classnames('sm:flex-1 sm:px-2', { 'mt-4': header })}>{body}</div>
          )}
        </div>
      )}
    </Fragment>
  );
}
